module.exports = __webpack_public_path__ + "img/search-icon.cb2ba6a.svg";